import * as React from 'react';
import { Input } from 'antd';
import { InputProps } from 'antd/lib/input/Input';
import styled from 'styled-components';
import { path } from 'ramda';
import { FormikContextType } from 'formik';
import { UploadOutlined, CloseOutlined } from '@ant-design/icons';

import { FormValues } from 'components/templates/form-mask';
import FormError from 'components/molecules/form-error';

export interface CustomInputProps {
  label?: string;
  subLabel?: string;
  name: string;
  formik: FormikContextType<FormValues>;
  fileType: string;
  savedValue?: string;
  value?: string;
  deleteFile?: () => void;
}
const Wrapper = styled.div`
  margin-top: 0.625rem;
`;
const Content = styled.div`
  display: flex;
  align-items: end;
`;
const Label = styled.label`
  font-size: ${path(['theme', 'font', 'size', 'body'])};
  font-weight: bold;
`;
const WrapperInput = styled.div`
  width: 100%;
  input {
    width: 100%;
    border-radius: 5px;
  }
  span {
    width: 110px;
  }
`;
const LeftIconWrapper = styled.div`
  margin-right: 10px;
`;
const RightIconWrapper = styled.div`
  margin-left: 10px;
`;

const UploadField = ({
  label,
  name,
  formik,
  fileType,
  savedValue,
  value,
  subLabel,
  deleteFile,
  ...inputProps
}: CustomInputProps & InputProps): React.ReactElement => {
  const hiddenFileInput = React.useRef<HTMLInputElement>(null);

  const handleClick = () => {
    hiddenFileInput?.current?.click();
  };

  const onUpload = (event: React.ChangeEvent) => {
    const target = event.target as HTMLInputElement;
    const file: File = (target.files as FileList)[0];
    formik.setFieldValue(name, file);
  };

  const handleDelete = () => {
    deleteFile?.();
  };

  return (
    <Wrapper>
      {label && <Label htmlFor={name}>{label}</Label>}
      <Content>
        <LeftIconWrapper>
          <UploadOutlined onClick={handleClick} style={{ fontSize: '28px' }} />
          <input type="file" onChange={onUpload} ref={hiddenFileInput} style={{ display: 'none' }} accept={fileType} />
        </LeftIconWrapper>
        <WrapperInput>
          <span>{subLabel}</span>
          <Input style={{ color: '#7F7F7F' }} disabled id={name} {...inputProps} value={value || savedValue} />
        </WrapperInput>
        {!!deleteFile && (
          <RightIconWrapper>
            <CloseOutlined onClick={handleDelete} style={{ fontSize: '28px', color: '#E53914' }} />
          </RightIconWrapper>
        )}
      </Content>
      <FormError formik={formik} fieldName={name} />
    </Wrapper>
  );
};

export default UploadField;
